import { CSSProperties } from "react";
import { css, DefaultTheme } from "styled-components";
import {
  getNewLookTokens,
  NEW_LOOK_RADIUS,
  newLookType,
} from "common/NewLook/tokens.ts";

/**
 * Phone lists (trades, signals) as one panel of rows, like the dashboard's
 * lists: the sorters are the panel's micro column header, each card is a row
 * with a hairline under it, and the last row closes the panel.
 */
export type NewLookListRow = "middle" | "last";

/** The panel's top edge and its column header (the sorters row). */
export const newLookListHead = (columns: string) => css`
  margin-top: 12px;
  background: ${(p) => getNewLookTokens(p.theme).panel};
  border: 1px solid ${(p) => getNewLookTokens(p.theme).hairline};
  border-radius: ${NEW_LOOK_RADIUS.panel}px ${NEW_LOOK_RADIUS.panel}px 0 0;
  > div:first-child {
    display: flex;
    align-items: center;
    min-height: 36px;
    padding: 0 32px 0 16px !important;
    margin: 0 !important;
    background: transparent;
    border-radius: 0;
    border-bottom: 1px solid ${(p) => getNewLookTokens(p.theme).hairline};
  }
  /* The same columns as the rows under it. */
  > div:first-child .ant-row {
    display: grid;
    grid-template-columns: ${columns};
    gap: 8px;
    > .ant-col {
      max-width: none;
      min-width: 0;
    }
  }
  > div:first-child .ant-row > div > div {
    ${newLookType.micro};
    white-space: nowrap;
  }
`;

/** Inline style that turns an expanding card into a row of the panel. */
export const getNewLookListRowStyle = (
  theme: DefaultTheme,
  position: NewLookListRow
): CSSProperties => {
  const { panel, hairline } = getNewLookTokens(theme);
  return {
    padding: "12px 16px",
    cursor: "pointer",
    background: panel,
    borderRadius:
      position === "last"
        ? `0 0 ${NEW_LOOK_RADIUS.panel}px ${NEW_LOOK_RADIUS.panel}px`
        : 0,
    boxShadow: `inset 1px 0 0 ${hairline}, inset -1px 0 0 ${hairline}, inset 0 -1px 0 ${hairline}`,
  };
};
